import React, { Component } from 'react';
import SvgIcon from './SvgIcon';

class Question extends Component {
  constructor(props) {
    super(props);

    // Intentionally ignore prop updates: this component will only ever render
    // a single question during its lifecycle
    // Setting the local state
    // Setting it with a value from props stops you from being able to
    // update this at a later time
    this.state = {
      question: props.question
    };

    this.fieldset = React.createRef();
  }

  componentDidMount() {
    // Focus on the fieldset so the next tab will take user to first option
    this.fieldset.current.focus();
  }

  render() {
    // Custom label lets us set a different label based on a specified prop
    let label =
      'customLabel' in this.state.question
        ? this.state.question.customLabel.get(
          /* eslint-disable */
            eval('this.props.' + this.state.question.customLabel.prop)
          )
        : this.state.question.questionText;

    // Get question colour
    const questionColour = this.state.question.questionColour.value;

    return (
      <div className="u-absolute u-pin-t u-pin-l u-w-full u-mt-0" ref={this.props.innerRef}>
        {/* Question number label */}
        <p className="u-pt-1/2 u-pb-1 u-px-2 u-inline-block u-w-auto u-bg-black u-text-white u-font-bold u-relative u-z-900">
          {/* Plus 1 for a 1-indexed number */}
          Question {this.props.currentQuestion + 1} of {this.props.totalQuestions}
        </p>

        {/* Main question */}
        <fieldset ref={this.fieldset} tabIndex={0} className={`u-mt-0 sm:u-border sm:u-border-solid sm:u-border-${questionColour}-500 u-text-lg u--mt-3`}>

          {/* Question image */}
          {this.state.question.questionImage !== null ? (
            <img src={this.state.question.questionImage.url} alt="" className={`u-mt-0 u-bg-${questionColour} u-w-full u-h-32 u-block u-object-cover`} />
          ) : null}

          {/* Question text box */}
          <div className={`u-bg-${questionColour}-500 u-text-white u-py-6 u-px-10 u-pt-8 u-mt-0 u-leading-tight u-flex u-flex-col u-items-center sm:u-flex-row sm:u-justify-start`}>
            {/* Question icon */}
            {this.state.question.questionIcon.value !== null && this.state.question.questionImage === null ? (
              <div className="question__icon u-flex u-justify-center sm:u-flex-row sm:u-w-2/6">
                <SvgIcon icon={this.state.question.questionIcon.value}/>
              </div>
            ) : null}

            {/* Question text */}
            {/* Constrain width of text only if there is an icon next to it */}
            <legend className={this.state.question.questionIcon.value !== null && this.state.question.questionImage === null ? 'sm:u-w-4/6' : ''} dangerouslySetInnerHTML={{__html: label}} />
          </div>

          {/* Question options */}
          <div className="u-flex u-items-center u-justify-center u-flex-col u-py-7 u-mt-0">
            {this.state.question.options.map((option, index) => (
              <button
                type="button"
                onClick={this.props.handleAnswer}
                name={`Question ${this.props.currentQuestion + 1}`}
                // Scores with value 0 come back from the api as null
                value={option.score === null ? 0 : option.score}
                data-answer-index={index}
                data-answer-text={option.answerText}
                data-question-number={`${this.props.currentQuestion + 1} of ${this.props.totalQuestions}`}
                className={`question-option u-w-full u-block sm:u-w-1/2 u-mt-2 button button--white u-bg-${questionColour}-500 u-text-white u-text-base u-text-left u-pl-4`}
                key={index}
              >
                {option.answerText}
              </button>
            ))}
          </div>
        </fieldset>

        {/* Back button */}
        {/* {this.state.question.name !== 'Question 1' ? (
          <button type="button" onClick={this.props.goBack} className="button button--back u-mt-4">
            Back
          </button>
        ) : null} */}
      </div>
    );
  }
}

export default Question;
